import { Alert } from "@heroui/react";
import { LuLightbulb } from "react-icons/lu";
import { ImageUploader } from "@/components/ui";

const MediaStep = ({ imageState, setImageState }) => {
    return (
        <div className="flex flex-col gap-4">
            <Alert
                color="warning"
                variant="flat"
                icon={
                    <div className="flex items-center justify-center">
                        <LuLightbulb size={18} className="mx-auto" />
                    </div>
                }
                title="Langkah ini opsional"
                description="Anda dapat menambahkan foto profil atau logo pelanggan. Format: JPG, PNG. Maksimal 2MB."
            />

            <ImageUploader
                images={imageState.items}
                onChange={(newItems) =>
                    setImageState((prev) => ({ ...prev, items: newItems }))
                }
                onDeleteExisting={(imageId) =>
                    setImageState((prev) => ({
                        ...prev,
                        deleted: [...prev.deleted, imageId],
                    }))
                }
                maxFiles={1}
                label="Foto Profil Pelanggan"
            />
        </div>
    );
};

export default MediaStep;
